import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PolicyLayout, { PolicySection } from "@/components/common/PolicyLayout";
import { Link } from "@/components/common/Link";
export default function ReturnsPage() {
  return <div>
      <Header />
      <PolicyLayout title="Returns & Refunds" intro="We want you to be completely satisfied with your purchase from AQUAFLAME. Please read our return and refund guidelines below." updated="October 2026">
        <PolicySection title="14-Day Return Window">
          <p>
            You have 14 days from the date of delivery to request a return for your item. Returns requested after this 14-day window cannot be accepted.
          </p>
        </PolicySection>

        <PolicySection title="Return Eligibility">
          <p>
            To qualify for a return and refund, all returned items must satisfy the following conditions:
          </p>
          <ul>
            <li>The item must be completely unused, unopened, and not installed.</li>
            <li>The item must be in its original manufacturer packaging with all internal padding and protective wraps intact.</li>
            <li>All included parts, accessories, hardware, manuals, and documentation must be present.</li>
          </ul>
        </PolicySection>

        <PolicySection title="Non-Returnable Items">
          <p>
            The following items and conditions are not eligible for return or refund:
          </p>
          <ul>
            <li>Units that have been installed, mounted, connected to gas or water supply lines, or used in any manner.</li>
            <li>Items that show signs of wear, modification, or cosmetic damage after delivery.</li>
            <li>Items damaged due to improper installation, misuse, neglect, or electrical/gas supply issues.</li>
          </ul>
        </PolicySection>

        <PolicySection title="How to Start a Return">
          <p>
            To initiate a return, please send an email to{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a> with your order number, the item you wish to return, and the reason for the return.
          </p>
          <p>
            We reply to emails within 1–2 business days with detailed return instructions and the designated return address. Please do not ship anything back before receiving these instructions, as unauthorized returns cannot be tracked or processed.
          </p>
        </PolicySection>

        <PolicySection title="Return Shipping Costs">
          <p>
            Return shipping costs are the responsibility of the buyer unless the return is due to an error on our part (such as receiving a damaged, defective, or incorrect item).
          </p>
          <p>
            Because water heaters and parts are heavy physical freight, we recommend using a trackable shipping service and retaining proof of postage. For questions regarding standard shipping rates and delivery logistics, please review our{" "}
            <Link to="/ShippingPage">Shipping Policy</Link>.
          </p>
        </PolicySection>

        <PolicySection title="Damaged, Defective, or Incorrect Items">
          <p>
            If your order arrives damaged, defective, or you receive an incorrect item, please email us at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a> within 14 days of delivery.
          </p>
          <p>
            Please include your order number along with clear photographs showing the item and packaging. Once verified, we will arrange a replacement or issue a full refund at no additional cost to you.
          </p>
        </PolicySection>

        <PolicySection title="Refund Process & Timing">
          <p>
            Once we receive and inspect your returned merchandise, we will process your refund to the original payment method used during checkout.
          </p>
          <p>
            The time required for the refund to reflect on your statement depends on your payment provider or banking institution. Please note that original shipping charges are non-refundable unless the return is the result of our error (such as a damaged, defective, or incorrectly dispatched item).
          </p>
        </PolicySection>

        <PolicySection title="Order Cancellations">
          <p>
            If you wish to cancel an order before it has shipped, please contact us immediately at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a> with your order number. Once an order has been dispatched from our facility, it cannot be canceled and must be processed under our standard return guidelines upon delivery.
          </p>
        </PolicySection>

        <PolicySection title="Contact Us">
          <p>
            If you have any questions concerning our returns and refunds policy, please email us at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>. We reply to emails within 1–2 business days.
          </p>
        </PolicySection>
      </PolicyLayout>
      <Footer />
    </div>;
}